import React from "react"
import PropTypes from "prop-types"
import i18n from "i18n"
import { Typography } from "@mui/material"

import { formatChartNumber } from "./utils/numberFormat"
import OverviewCard, {
  overviewCardValueSx,
  overviewCardHelperTextSx,
} from "./OverviewCard"

const EacCostCard = ({ eac_cost, isLoading, currency }) => (
  <OverviewCard
    iconPreset="eacCost"
    title={i18n.t("overview.eacCostCardTitle")}
    infoText={i18n.t("overview.eacCostCardTooltip")}
    loading={isLoading}
    sx={{ height: "100%" }}
  >
    <Typography sx={overviewCardValueSx}>
      {formatChartNumber(eac_cost, 2)} {currency}
    </Typography>
    <Typography variant="body2" sx={overviewCardHelperTextSx}>
      {i18n.t("overview.eacCostCardHelper")}
    </Typography>
  </OverviewCard>
)

EacCostCard.propTypes = {
  eac_cost: PropTypes.number.isRequired,
  isLoading: PropTypes.bool,
  currency: PropTypes.string,
}

export default EacCostCard
